export const ENV={
 stakeAddress:process.env.REACT_APP_STAKE_ADDRESS,
 tokenAddress:process.env.REACT_APP_TOKEN_ADDRESS
}